import { useState } from "react";
import { useAuthContext } from '@/context/AuthContext';
import { useParams } from "react-router-dom";
import {userManager} from '@/components/authentication/keycloak.js';

export const useGetConsultantPayslip = ( ) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const [file, setFile] = useState(null);
  const { id: consultantUuid } = useParams();
  if (!consultantUuid) return;

  const getConsultantPayslip = async (payslipFileUuid) => {
    setLoading(true);
    setError(null);
    const user = await userManager.getUser();
    // console.log("getConsultantPayslip ", payslipFileUuid)

    try {
      const response = await fetch(
        window.ENV.BACKEND_URL+`/api/secured/admin/payslip/payslipFile/${consultantUuid}/${payslipFileUuid}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user.access_token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch payslip");
      }

    //   const fileBlob = await response.blob();
    //   setFile(fileBlob);


      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
    //   console.log("blob file payslip ", blob, url)

      setData({ url, type: blob.type });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { getPayslip :getConsultantPayslip, loading, error, data };
};
